<ui-switch
  class="d-flex custom-switch-toggle"
  [beforeChange]="beforeChange$"
  [ngModel]="isActive"
  [disabled]="disabled"
  (valueChange)="valueChange.emit($event)"
  size="small">
</ui-switch>
